import DefaultApi from './DefaultApi';

const api = new DefaultApi();

export default api;